/* eslint-disable @typescript-eslint/ban-ts-comment */
import React, { Suspense } from 'react';
import 'antd/dist/antd.css';
import './App.scss';
import { Spin } from 'antd';
import ClustersData from './devData.json';
import { Footer } from './components/Footer';
import { useStore, IState, IDataUnit, ISidebarFilter } from './state';

const Nav = React.lazy(() => import('./modules/nav'));
const Sidebar = React.lazy(() => import('./modules/sidebar'));
const Hero = React.lazy(() => import('./components/Hero'));
const PageTabs = React.lazy(() => import('./components/PageTabs'));
export const allData: any = ClustersData;

const App = () => {
  // const [data, setData] = React.useState<any>(allData);

  const sidebarFilterStore: ISidebarFilter = useStore(
    (state: IState) => state.sidebarFilterStore
  );
  const setAllDataStore: IState['setAllDataStore'] = useStore(
    (state) => state.setAllDataStore
  );
  const updateAllData = (newData: IDataUnit[]) => {
    setAllDataStore(newData);
  };

  // const [sidebarFilters, setSidebarFilters] = React.useState<{
  //   date?: { type: string; value: string };
  //   displayUnit?: string;
  //   sliderValue?: string | number;
  // }>(initialFilters);

  const [isLoading, setIsLoading] = React.useState(false);
  React.useEffect(() => {
    const initialData = allData.filter((transaction: any) => {
      return (
        // @ts-ignore
        new Date(sidebarFilterStore?.date.value).getFullYear() ===
        new Date(transaction.trans_date).getFullYear()

        // new Date(sidebarFilters?.date.value).getFullYear() ===
        // new Date(transaction.trans_date).getFullYear()
      );
    });
    // setData(initialData);
    updateAllData(initialData);
  }, []);

  return (
    <div className="App">
      <Hero />
      <main
        className="App__content"
        style={{
          paddingBottom: '32px',
          paddingTop: '32px',
        }}
      >
        <PageTabs setIsLoading={setIsLoading} />
        <div className="App__content--grid">
          <Sidebar
            // setData={setData}
            setIsLoading={setIsLoading}
            // setSidebarFilters={setSidebarFilters}
            // sidebarFilters={sidebarFilters}
            // initialDate={initialFilters.date.value}
          />
          <Suspense>
            <div className="main">
              <Spin size="large" tip="Loading data..." spinning={isLoading}>
                <Nav
                  // data={data}
                  // sidebarFilters={sidebarFilters}
                  setIsLoading={setIsLoading}
                />
              </Spin>
            </div>
          </Suspense>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default App;
